import { Await, useLoaderData } from "react-router";
import { Suspense } from "react";
import { LoaderWrapper } from "./LoaderPage";
import { GamePage } from "./gamePage";

export const AwaitGamePage = () => {
      const { userSavedDataLoader } = useLoaderData();

      return (
            <Suspense fallback={<div>loading...</div>}>
                  <Await resolve={userSavedDataLoader}>
                        <LoaderWrapper>
                              {({ backgroundSoundTwo }) => (
                                    <GamePage backgroundSoundTwo={backgroundSoundTwo} />
                              )}
                        </LoaderWrapper>
                  </Await>
            </Suspense>
      );
};
